/**************************************************************************
Name:         jquery.fayt.js
Description:  Find-as-you-type widget.
Date Created: 12/19/2013 by Kyle Brickman
Modified:
**************************************************************************/

( function( $ ){
	$.fn.fayt = function( options )
	{
		var settings = $.extend({
			single             : true,
			classname          : '',
			inputClassname     : '',
			addButtonClassname : '',
			component          : '',
			method             : '',
			arguments          : {},
			minLength          : 1,
			maxLength          : 20,
			optional           : false,
			resultRequired     : false,
			saveText           : true,
			acceptPartials     : false,
			saveTextFrom       : 'default',
			placeholder        : 'Find As You Type',
			defaultLabel       : 'Search for results',
			noRowsLabel        : 'No results found',
			outerLabel 		   : false,
			isSelected 		   : false,
			retain 			   : false,
			onAdd              : function( ){ },
			onSelect           : function( ){ },
			onInputChange	   : function( ){ },
			onTest             : function( value ){ return true; }
		}, options );

		return this.filter( 'input:not([type="radio"],[type="checkbox"])' ).each( function( index ){
			// Instantiate bound functions
			var showNoRows = function( )
			{
				local.results.css(  'height', '30px' );
				local.results.addClass(     'active' );
				local.textNoRows.addClass(  'active' );
				local.spinner.removeClass( 'active' );

				//$( 'body' ).trigger( 'noFaytResults' );
			};

			var showDefault = function( )
			{
				local.results.css(  'height', '30px' );
				local.results.addClass(     'active' );
				local.textDefault.addClass(  'active' );
				local.spinner.removeClass( 'active' );
			};

			var inputFocus = function( )
			{
				$( 'li:not(.spinner,.textDefault,.textNoRows)', local.results ).remove( );
				showDefault( )
			};

			var inputChange = function( evt )
			{
				clearTimeout( local.timeout );

				// Enter key pressed - select highlighted result
				if( 13 == evt.which )
				{
					$( 'li.selected', local.results ).trigger( 'mousedown' );
					local.input.trigger( 'blur' );
					return;
				}

				// Escape key pressed - cancel input
				if( 27 == evt.which )
				{
					local.input.trigger( 'blur' );
					return;
				}

				// Move highlighted result up one space
				if( 38 == evt.which )
				{
					if( $( 'li.selected', local.results ).prev( 'li[data-id]' ).length )
						$( 'li.selected', local.results ).prev( 'li[data-id]' ).trigger( 'mouseover' );
					else
						$( 'li[data-id]', local.results ).last( ).trigger( 'mouseover' );

					return;
				}

				// Move highlighted result down one space
				if( 40 == evt.which )
				{
					if( $( 'li.selected', local.results ).next( 'li[data-id]' ).length )
						$( 'li.selected', local.results ).next( 'li[data-id]' ).trigger( 'mouseover' );
					else
						$( 'li[data-id]', local.results ).first( ).trigger( 'mouseover' );

					return;
				}

				// Non-input-changing key pressed - don't trigger network event
				if( 35 == evt.which || 36 == evt.which || 37 == evt.which || 39 == evt.which )
					return;

				var trimmed = local.input.val( ).trim( );

				if( (trimmed.length >= local.settings.minLength && trimmed.length <= local.settings.maxLength) || 31 <= local.results.height( ))
				{
					$( 'li', local.results ).removeClass( 'active' );
					local.results.removeClass(  'active' );
					local.results.removeAttr(    'style' );
				}

				// Find overflow hidden parent height
				var overflowParent = local.wrapper.parents( ).filter( function( ){
					var element   = $( this );
					var position  = element.css( 'position' );
					var overflow  = element.css( 'overflow' );
					var overflowY = element.css( 'overflow-y' );

					return ( 'absolute' == position || 'relative' == position || 'static' == position ) && ( 'hidden' == overflow || 'hidden' == overflowY );
				});

				local.timeout = setTimeout( function( ){
					$( 'li[data-value]', local.results ).remove( );
					local.add.prop( 'disabled', true );

					if( trimmed.length >= local.settings.minLength && trimmed.length <= local.settings.maxLength )
					{
						local.data        = jQuery.extend( true, {}, local.settings.arguments );
						local.data.method = local.settings.method;
						local.data.search = local.input.val( ).trim( );
						local.spinner.addClass( 'active' );

						$.each( local.settings.arguments, function( index, value ){
							if( $.isFunction( value ))
								local.data[index] = value( );
						});

						local.add.prop( 'disabled', !local.settings.onTest( local.data.search ));

						$.ajax({
							url      : '/cfcs/' + local.settings.component + '.cfc',
							cache    : false,
							dataType : 'json',
							data     : local.data,
							error    : function (xhr, status, err){
								var errorMsg = err;
								// console.log(err);
							},
							success  : function( results ){
								if( overflowParent.length ) {
									var listHeight = (( results.length + ( local.settings.resultRequired ? 0 : 1 )) * 30 );

									var listPos = local.results.offset().top;
									var overflowParentPos = overflowParent.first( ).offset().top;
									var posDifference = listPos - overflowParentPos;

									var maxHeight  = overflowParent.first( ).height( ) - posDifference;
									if (maxHeight < 0)
										maxHeight = 150;

									if( listHeight > maxHeight ){
										local.results.css( { 'height':maxHeight + 'px','overflowY':'visible' } )
									} else {
										local.results.css( 'height', listHeight + 'px' );
									}
								} else {
									local.results.css( 'height', (( results.length + ( local.settings.resultRequired ? 0 : 1 )) * 30 ) + 'px' );
								}
								local.results.addClass(     'active' );
								local.spinner.removeClass( 'active' );

								if( !local.settings.resultRequired )
								{
									var tempItem = $( '<li />' );
									tempItem.attr( 'data-id',    0 );
									tempItem.attr( 'data-value', local.data.search );
									tempItem.attr( 'data-title', local.data.search );

									var title = $( '<span />' );
									title.text( local.data.search );
									title.addClass( 'full' );
									title.appendTo( tempItem );

									tempItem.appendTo( local.results );
									tempItem.addClass( 'active selected' );
								}
								else if( !results.length )
									local.add.prop( 'disabled', true )

								if( !results.length )
									return showNoRows( );

								for( var i = 0; i < results.length; i++ )
								{
									var result = results[i];

									var item = $( '<li />' );

									item.attr( 'data-id',    result.id    );
									item.attr( 'data-value', result.value );
									item.attr( 'data-title', result.title );

									var title = $( '<span />' );
									title.text( result.title );
									title.appendTo( item );

									if( undefined != result.subtitle && result.title != result.subtitle )
									{
										var subtitle = $( '<span />' );
										subtitle.text( result.subtitle );
										subtitle.appendTo( item );
									}
									else
									{
										title.addClass( 'full' );
									}

									item.appendTo( local.results );
									item.addClass( !i && local.settings.resultRequired ? 'active selected' : 'active' );
								}
							}
						})
					}
					else
						showDefault( );
				}, 500 );

				local.settings.onInputChange( );
			};

			var inputBlur = function( )
			{
				$( 'li', local.results ).removeClass( 'active' );
				local.spinner.removeClass( 'active' );
				local.results.removeAttr( 'style' );
				local.results.removeClass( 'active' );

				if( local.settings.isSelected ) {
					if( !local.settings.saveText )
						local.input.val( '' );
					else if( 'title' == local.settings.saveTextFrom )
						local.input.val( local.hidden.attr( 'data-title' ))
					else if( 'id' == local.settings.saveTextFrom )
						local.input.val( local.hidden.attr( 'data-id' ))
					else if( 'value' == local.settings.saveTextFrom )
						local.input.val( local.hidden.attr( 'data-value' ))

					local.settings.isSelected = false;

				} else if( local.settings.acceptPartials )
					local.hidden.val( local.input.val() );
			};

			var resultAdd = function( )
			{
				local.wrapper.removeClass( 'error' );
			};

			var resultSelect = function( )
			{
				local.hidden.val(                $( this ).attr( 'data-value' ));
				local.hidden.attr( 'data-id',    $( this ).attr( 'data-id'    ));
				local.hidden.attr( 'data-value', $( this ).attr( 'data-value' ));
				local.hidden.attr( 'data-title', $( this ).attr( 'data-title' ));
				local.input.val(                 $( this ).attr( 'data-value' ));

				local.add.prop( 'disabled', !local.settings.onTest( local.input.val( )));

				local.settings.isSelected = true;
			};

			var resultOver = function( )
			{
				$( this ).trigger( 'mouseout' );
				$( this ).addClass( 'selected' );
			};

			var resultOut = function( )
			{
				$( 'li', local.results ).removeClass( 'selected' );
			};

			// Establish root container
			var local = {};

			// Establish local settings
			local.settings = settings;
			local.timeout  = 0;

			// Retrieve and create DOM elements
			local.container   = $( this ).parent( );
			local.placeholder = $( '<span   />' );
			local.wrapper     = $( '<div    />' );
			local.hidden      = $( '<input  />' );
			local.spinner     = $( '<span   />' );
			local.input       = $( this );
			local.results     = $( '<ol     />' );
			local.textDefault = $( '<li     />' );
			local.textNoRows  = $( '<li     />' );
			local.add         = $( '<input  />' );

			// Insert temporary placeholder
			local.placeholder.insertBefore( local.input );
			local.input.detach( );

			// Set attributes
			local.hidden.attr(       'type', 'hidden' );
			local.hidden.attr( 'data-id',          '' );
			local.hidden.attr( 'data-value',       '' );
			local.hidden.attr( 'data-title',       '' );
			local.hidden.attr(       'name', undefined != local.input.attr( 'name' ) ? local.input.attr( 'name' ) : 'fayt' + index );
			local.hidden.attr(         'id', undefined != local.input.attr(   'id' ) ? local.input.attr(   'id' ) : local.hidden.attr( 'name' ));

			if( local.settings.retain ) local.hidden.attr( 'data-retain', true );

			local.input.removeAttr( 'name id class style value placeholder optional' );

			if( local.settings.optional )
				local.input.attr( 'optional', '' );

			local.add.attr(  'type', 'button' );
			local.add.attr( 'value', '+' )
			local.add.prop( 'disabled', true );

			local.input.attr( 'placeholder', local.settings.placeholder );

			local.textDefault.text( local.settings.defaultLabel );
			local.textNoRows.text(  local.settings.noRowsLabel  );

			// Set classes
			local.wrapper.addClass(            'fayt' );
			local.spinner.addClass(         'network' );
			local.textDefault.addClass( 'textDefault' );
			local.textNoRows.addClass(   'textNoRows' );

			if( local.settings.single 	  ) local.wrapper.addClass( 'single'  	 );
			if( local.settings.outerLabel ) local.wrapper.addClass( 'outerLabel' );

			local.wrapper.addClass( local.settings.classname );
			local.input.addClass( local.settings.inputClassname );
			local.add.addClass( local.settings.addButtonClassname );

			// Bind events
			local.input.on( 'keydown keypress keyup', function( evt ){ if( 13 == evt.which ) evt.preventDefault( ); });
			local.input.on( 'focus', inputFocus  );
			local.input.on( 'keyup', inputChange );
			local.input.on(  'blur', inputBlur   );

			local.add.on( 'click', resultAdd );
			local.results.on( 'mousedown touchend', 'li:not(.textDefault,.textNoRows)', resultSelect );
			local.results.on( 'mouseover', 'li:not(.textDefault,.textNoRows)', resultOver   );
			local.results.on( 'mouseout',  'li:not(.textDefault,.textNoRows)', resultOut    );

			local.add.on( 'click', local.settings.onAdd );
			local.results.on( 'mousedown touchend', 'li:not(.textDefault,.textNoRows)', local.settings.onSelect );

			// Append elements
			local.textDefault.appendTo( local.results );
			local.textNoRows.appendTo(  local.results );
			local.hidden.appendTo(      local.wrapper );
			local.spinner.appendTo(     local.wrapper );
			local.input.appendTo(       local.wrapper );
			local.add.appendTo(         local.wrapper );
			local.results.appendTo(     local.wrapper );

			local.wrapper.insertAfter( local.placeholder );

			local.placeholder.remove( );
		});
	};
})( jQuery );

if( typeof String.prototype.trim !== 'function' )
	String.prototype.trim = function( )
	{
		return this.replace( /^\s+|\s+$/g, '' );
	}
